import React, { useCallback } from "react";
import { Button } from "../../../../../design/button";
import { useAuth } from "../../../../../contexts/AuthContext";
import { useAccount } from "../../../../../contexts/AccountContext";

const GoogleCalendarButton: React.FC = () => {
  const { user } = useAuth();
  const { account } = useAccount();

  const handleNylasButtonClick = useCallback(() => {
    if (!user) return;
    
    const client_id = account.nylasClientId ?? process.env.REACT_APP_NYLAS_CLIENT_ID;
    const redirect_uri = window.location.origin + "/callback/nylas";
    const response_type = "code";
    const prompt = "detect";
    const url = `https://api.us.nylas.com/v3/connect/auth?client_id=${client_id}&redirect_uri=${redirect_uri}&response_type=${response_type}&prompt=${prompt}&login_hint=${user.email}`;
    window.open(url, "_blank");
  }, [user, account.nylasClientId]);

  return <Button onClick={handleNylasButtonClick}>Connect</Button>;
};

export default GoogleCalendarButton;
